import React, { useState, useEffect, useRef } from "react";
import { TextArea, withField } from "@douyinfe/semi-ui";
import { JobTypeEnum, VhhDesignTypeEnum } from "@services/home/enum/home.enum";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";

// const binderHint =
//   "What biomolecule would you like to design a protein binder for?";

interface Prop {
  value?: string;
  select_type?: string;
  job_type: string;
  onChange?: (value: string) => void;
  submit: (v: string) => void;
}

const MainTextarea: React.FC<Prop> = ({
  value,
  select_type,
  job_type,
  onChange,
  submit,
}) => {
  const { t, i18n } = useTranslation();
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const [placeholderList, setPlaceholderList] = useState<string[]>([]);

  const [inputText, setInputText] = useState("");

  const getPlaceholderText = (
    type: string,
    inputType: VhhDesignTypeEnum
  ): string => {
    const jobType = type.split("-")[0] as JobTypeEnum;
    /* eslint-disable */
    // @ts-ignore: Unreachable code error
    return t(`homePage.placeholder.${jobType}.${inputType}` as any) as string;
    /* eslint-enable */
  };

  function handleInput(e: React.MouseEvent<HTMLTextAreaElement, MouseEvent>) {
    const target = e.target as HTMLTextAreaElement;
    setInputText(target.value);

    if (onChange) {
      onChange(target.value);
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      const target = event.target as HTMLTextAreaElement;
      const val = target.value.trim();

      submit(val);
    }
  };

  // function getPlaceholder(jobType: string, type?: string) {
  //   if (jobType.startsWith(JobTypeEnum.PeptideDesignLite)) {
  //     if (type === VhhDesignTypeEnum.PdbID) {
  //       return `${peptideHint}\nFetch the experimental structure that includes your target antigen, e.g. 6xc3`;
  //     } else if (type === VhhDesignTypeEnum.UniProtID) {
  //       return `${peptideHint}\nFetch the AF2-predicted structure for your target antigen, e.g. P0DTC2`;
  //     }
  //   } else if (type === VhhDesignTypeEnum.PdbID) {
  //     return `${vhhHint}\nFetch the experimental structure that includes your target antigen, e.g. 6xc3`;
  //   } else if (type === VhhDesignTypeEnum.UniProtID) {
  //     return `${vhhHint}\nFetch the AF2-predicted structure for your target antigen, e.g. P0DTC2`;
  //   } else if (type === VhhDesignTypeEnum.AntigenSequence) {
  //     return `${vhhHint}\nPredict the structure of your antigen sequence with ESMFold, e.g. MFVFLVLLPLVSSQCV...`;
  //   } else if (type === VhhDesignTypeEnum.UploadStructure) {
  //     return "";
  //   } else if (type === BinderDesignTypeEnum.Ligand) {
  //     return `${binderHint}\nEnter a valid SMILES string, e.g. CCCC(C=O)O`;
  //   } else if (type === BinderDesignTypeEnum.LigandCCD) {
  //     return `${binderHint}\nEnter a valid CCD code, e.g. URC`;
  //   } else if (type === BinderDesignTypeEnum.RnaSequence) {
  //     return `${binderHint}\nEnter an RNA sequence, e.g. AUCGGCAAAGGAGCCCAA...`;
  //   } else if (type === BinderDesignTypeEnum.RnaSequenceDs) {
  //     return `${binderHint}\nEnter an RNA sequence, e.g. AUCGGCAAAGGAGCCCAA... The complementary sequence will be derived automatically.`;
  //   } else if (type === BinderDesignTypeEnum.DnaSequence) {
  //     return `${binderHint}\nEnter an DNA sequence, e.g. AUCGGCAAAGGAGCCCAA...`;
  //   } else if (type === BinderDesignTypeEnum.DnaSequenceDs) {
  //     return `${binderHint}\nEnter a DNA sequence, e.g. GCCAATTA... The reverse complement will be derived automatically.`;
  //   } else if (type === BinderDesignTypeEnum.ProteinChain) {
  //     return `${binderHint}\nEnter a protein sequence, e.g. GQLEEIAKQLEEIAWQLEEIAQG...`;
  //   }

  //   return "";
  // }

  function processData(jobType: string, v: string) {
    const text = getPlaceholderText(jobType, v as VhhDesignTypeEnum);
    const arr = text.split("\n");

    setPlaceholderList(arr);
  }

  useEffect(() => {
    if (select_type) {
      processData(job_type, select_type);
    }
  }, [job_type, select_type, i18n.resolvedLanguage]);

  useEffect(() => {
    if (value) {
      setInputText(value);
    }
  }, [value]);

  return (
    <div className={styles.textareaContainer}>
      <TextArea
        ref={textareaRef}
        className={styles.textarea}
        autosize={{ minRows: 2, maxRows: 3 }}
        onKeyDown={handleKeyDown}
        onInput={handleInput}
        value={inputText}
      />

      {!inputText && (
        <div className={styles.placeholder}>
          {placeholderList.map((text, i) => {
            return <div key={i}>{text}</div>;
          })}
        </div>
      )}
    </div>
  );
};

export default withField(MainTextarea);
